/* TypeScript file generated from DogPaintingsPage.res by genType. */

/* eslint-disable */
/* tslint:disable */

import * as DogPaintingsPageJS from './DogPaintingsPage.re.mjs';

export type props = {};

export const make: React.ComponentType<{}> = DogPaintingsPageJS.make as any;

export const $$default: React.ComponentType<{}> = DogPaintingsPageJS.default as any;

export default $$default;
